import { useQuery } from 'react-query';
import { QueryOptions } from '../types';
import configService from './config.service';

export function useConfig(options: QueryOptions<typeof configService.get>) {
	const { data, ...result } = useQuery('config', configService.get, options);
	return { config: data!, ...result };
}
